/**
 * Removes the VM list's CPU/RAM readings that earlier releases shared between browser tabs through
 * localStorage. The list now keeps those readings in the React Query cache only, so nothing writes
 * these keys any more — but a browser that ran an older build still holds them, and they are cleared
 * with the rest of the session. Kept free of any service import so clearSessionData can reach it
 * without an import cycle through the auth store.
 */

/** localStorage key prefix used by the retired cross-tab usage cache. */
const SHARED_USAGE_KEY_PREFIX = "wicloud:vm-usage:";

/** Removes every stored reading — on sign-out, since a VM can change hands (ownership transfer). */
export function clearSharedUsage(): void {
  try {
    const keys: string[] = [];
    for (let index = 0; index < localStorage.length; index++) {
      const key = localStorage.key(index);
      if (key?.startsWith(SHARED_USAGE_KEY_PREFIX)) {
        keys.push(key);
      }
    }
    for (const key of keys) {
      localStorage.removeItem(key);
    }
  } catch {
    // Storage blocked: there is nothing stored to clear.
  }
}
